import { Icon } from 'antd';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import servers from '../../utils/servers';
import { getAircraftTripEntries } from '../../models/trips/actions';
import rightArrow from '../../assets/trip-arrow.svg';
import styles from './OverviewRecentTrips.module.less';

class OverviewRecentTrips extends Component {
  static propTypes = {
    aircraft: PropTypes.object,
    intl: PropTypes.object.isRequired,
    tripsArr: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
  };

  static defaultProps = {
    aircraft: {},
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { aircraft, dispatch } = this.props;
    if (aircraft) {
      dispatch(
        getAircraftTripEntries({
          payload: aircraft.id,
        }),
      );
    }
  }

  componentDidUpdate(prevProps) {
    const { aircraft, dispatch } = this.props;
    if (aircraft !== prevProps.aircraft) {
      dispatch(
        getAircraftTripEntries({
          payload: aircraft.id,
        }),
      );
    }
  }

  getSectorStatus = (status) => {
    switch (status) {
      case 'partial':
        return {
          badgeStyle: styles.statusBadgeBlue,
          boxStyle: styles.statusMessageBlue,
          messageId: 'status.partial',
        };
      case 'in_progress':
        return {
          badgeStyle: styles.statusBadgeBlue,
          boxStyle: styles.statusMessageBlue,
          messageId: 'status.inProgress',
        };
      case 'planned':
        return {
          badgeStyle: styles.statusBadgeLightGrey,
          boxStyle: styles.statusMessageLightGrey,
          messageId: 'status.planned',
        };
      case 'error':
        return {
          badgeStyle: styles.statusBadgeRed,
          boxStyle: styles.statusMessageRed,
          messageId: 'status.error',
        };
      default:
        return {
          badgeStyle: styles.statusBadgeGreen,
          boxStyle: styles.statusMessageHidden,
          messageId: 'status.complete',
        };
    }
  };

  sectorRow = (flight, index) => {
    const {
      intl: { formatMessage },
      aircraft,
    } = this.props;

    const statusFormat = this.getSectorStatus(flight.status);

    return (
      <div key={flight.id} className={styles.rowWrapper} data-testid={`OverviewRecentTrips--sector${flight.id}`}>
        <Link
          to={{
            pathname: `/operations/flights/${flight.id}`,
            state: { fromLocation: 'overview', fromAircraft: aircraft.id },
          }}
        >
          <div className={styles.statusWrapper} data-testid={`OverviewRecentTrips--sectorStatus${flight.id}`}>
            <div className={statusFormat.badgeStyle} />
            <div className={styles.sectorNumber}>
              {formatMessage({ id: 'title.sector' })} {index + 1}
            </div>
            <div className={statusFormat.boxStyle}>
              <div className={styles.statusMessageText}>{formatMessage({ id: statusFormat.messageId })}</div>
            </div>
          </div>
          <div className={styles.depArrWrapper} data-testid={`OverviewRecentTrips--sectorDepArr${flight.id}`}>
            <div className={styles.airportLabel}>{flight.departure_airport}</div>
            {flight.time_offblocks ? (
              <div className={styles.timeLabel}>
                {`(${moment(flight.time_takeoff)
                  .utc()
                  .format('HH:mm')})`}
              </div>
            ) : (
              ''
            )}
            <div className={styles.depArrDivider}>
              <img src={rightArrow} alt="rarrow" />
            </div>
            <div className={styles.airportLabel}>{flight.arrival_airport}</div>
            {flight.time_onblocks ? (
              <div className={styles.timeLabel}>
                {`(${moment(flight.time_landing)
                  .utc()
                  .format('HH:mm')})`}
              </div>
            ) : (
              ''
            )}
            <div className={styles.openFlightChevron}>
              <Icon type="right" />
            </div>
          </div>
        </Link>
      </div>
    );
  };

  lastThreeTrips = (tripsArr) => {
    const {
      intl: { formatMessage },
    } = this.props;
    const trips = tripsArr.slice(0, 3).map((tripNum) => (
      <div key={tripNum.number}>
        <div key={tripNum.number} className={styles.tripCard} data-testid="OverviewRecentTrips--tripCard">
          <div className={tripNum.flights ? styles.tripHeaderWrapper : styles.tripHeaderWrapperNoSectors}>
            <div className={styles.numberWrapper} data-testid={`OverviewRecentTrips--tripNumber${tripNum.number}`}>
              <div className={styles.tripNumber}>{`#${tripNum && tripNum.number}`}</div>
              <div className={styles.tripDate}>{tripNum && tripNum.date}</div>
            </div>
            <div className={styles.nameWrapper} data-testid={`OverviewRecentTrips--tripPilot${tripNum.number}`}>
              <div className={styles.peopleNames}>
                <div>
                  {tripNum && tripNum.captain && tripNum.captain.first_name}{' '}
                  {tripNum && tripNum.captain && tripNum.captain.last_name}
                  {tripNum && tripNum.first_officer && ','}{' '}
                </div>
                <div className={styles.firstOfficerDiv}>
                  {tripNum && tripNum.first_officer && tripNum.first_officer.first_name}{' '}
                  {tripNum && tripNum.first_officer && tripNum.first_officer.last_name}
                </div>
              </div>
              <div className={`${styles.pdfWrapper} ${styles.SRPPdf}`}>
                <a
                  href={`${servers.api}/srp/${tripNum.id}.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`OverviewRecentTrips--srpLink${tripNum.number}`}
                >
                  {formatMessage({ id: 'text.srp' })}
                  <Icon type="file-pdf" className={styles.pdfIcon} />
                  {tripNum.number}
                </a>
              </div>
              {tripNum && tripNum.type === 'Trip' ? (
                <div className={styles.pdfWrapper}>
                  <a
                    href={`${servers.api}/srp/journey_log/${tripNum.id}.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`OverviewRecentTrips--jlLink${tripNum.number}`}
                  >
                    {formatMessage({ id: 'text.jl' })}
                    <Icon type="file-pdf" className={styles.pdfIcon} />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
          <div className={styles.tripListWrapper}>
            {tripNum.flights && tripNum.flights.map((flight, sectorIndex) => this.sectorRow(flight, sectorIndex))}
          </div>
        </div>
        <div
          key={`${tripNum.number} mobile`}
          className={styles.tripCardMobile}
          data-testid="OverviewRecentTrips--tripCardMobile"
        >
          <div className={tripNum.flights ? styles.tripHeaderWrapper : styles.tripHeaderWrapperNoSectors}>
            <div className={styles.mobileTripHeader}>
              <div
                className={styles.numberWrapper}
                data-testid={`OverviewRecentTrips--tripNumberMobile${tripNum.number}`}
              >
                <div className={styles.tripNumber}>{`#${tripNum && tripNum.number}`}</div>
                <div className={styles.tripDate}>{tripNum && tripNum.date}</div>
              </div>
              <div className={styles.nameWrapper} data-testid={`OverviewRecentTrips--tripPilotMobile${tripNum.number}`}>
                <div className={styles.peopleNames}>
                  <div>
                    {tripNum && tripNum.captain && tripNum.captain.first_name}{' '}
                    {tripNum && tripNum.captain && tripNum.captain.last_name}
                    {tripNum && tripNum.first_officer && ','}{' '}
                  </div>
                  <div className={styles.firstOfficerDiv}>
                    {tripNum && tripNum.first_officer && tripNum.first_officer.first_name}{' '}
                    {tripNum && tripNum.first_officer && tripNum.first_officer.last_name}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.mobileSRPLayout}>
              <div className={`${styles.pdfWrapper} ${styles.SRPPdf}`}>
                <a
                  href={`${servers.api}/srp/${tripNum.id}.pdf`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`OverviewRecentTrips--srpLinkMobile${tripNum.number}`}
                >
                  {formatMessage({ id: 'text.srp' })}
                  <Icon type="file-pdf" className={styles.pdfIcon} />
                  {tripNum.number}
                </a>
              </div>
              {tripNum && tripNum.type === 'Trip' ? (
                <div className={styles.pdfWrapper}>
                  <a
                    href={`${servers.api}/srp/journey_log/${tripNum.id}.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`OverviewRecentTrips--jlLinkMobile${tripNum.number}`}
                  >
                    {formatMessage({ id: 'text.jl' })}
                    <Icon type="file-pdf" className={styles.pdfIcon} />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
          <div className={styles.tripListWrapper}>
            {tripNum.flights && tripNum.flights.map((flight, sectorIndex) => this.sectorRow(flight, sectorIndex))}
          </div>
        </div>
      </div>
    ));
    return trips;
  };

  render() {
    const { tripsArr } = this.props;
    return (
      <div className={styles.tripContainer} data-testid="OverviewRecentTrips--tripsTable">
        {this.lastThreeTrips(tripsArr)}
      </div>
    );
  }
}

const overviewRecentTripsWithRedux = connect(({ trips }, { aircraft }) => {
  const tripsArr = Array.from(trips.tripsMap.values())
    .filter((tripEntry) => aircraft && tripEntry.aircraft_id === aircraft.id)
    .sort((a, b) => moment(b.date).diff(moment(a.date)));
  let tripUpdate = {};
  if (trips.newTrip) {
    tripUpdate = trips.newTrip;
  }
  return {
    tripUpdate,
    tripsArr,
  };
})(OverviewRecentTrips);

export default withRouter(injectIntl(overviewRecentTripsWithRedux));
